import Container from '@material-ui/core/Container';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import {
  type AfterPageProps,
  createApiClient,
  createInitialPropsRedirectToLogin,
  makeAfterComponent,
  wrapLayout,
} from '../../@sprinx/react-after-razzle';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';
import commonThingsToLoad from '../../api/commonThingsToLoad';

export type NewsPageProps = AfterPageProps;
export type NewsPageClassNameKey = 'root';

const useStyles = makeStyles(() =>
  createStyles<NewsPageClassNameKey, {}>({
    root: {},
  }),
);

const NewsPage: React.FC<NewsPageProps> = () => {
  const classes = useStyles();

  return (
    <>
      <Container>
        <div className={classes.root}>
          <h1>Aktuality</h1>

          <h2>Zde je místo pro aktuality</h2>
        </div>
      </Container>
    </>
  );
};

NewsPage.displayName = 'NewsPage';

export default makeAfterComponent(
  wrapLayout<NewsPageProps>(NewsPage, InfoLayout),
  async ({ match, initialAppProps }) => {
    try {
      if (initialAppProps) {
        const appProps = initialAppProps;
        const apiClient = createApiClient({ accessToken: appProps.auth?.accessToken });
        const commonThings = await Promise.all(commonThingsToLoad.promises({ apiClient }));
        appProps.propagateToState({
          ...commonThingsToLoad.toRegister(commonThings),
        });
      }
      return {};
    } catch (error) {
      if (error.response?.status === 401) {
        return createInitialPropsRedirectToLogin({ match });
      }
      return { error };
    }
  },
);
